// removed by extract-text-webpack-plugin
module.exports = {"wrap":"src-components-Showcase----Showcase-module---wrap---iVMqY","title":"src-components-Showcase----Showcase-module---title----HiMZ","media":"src-components-Showcase----Showcase-module---media---1sG3f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Showcase/Showcase.module.scss
// module id = 284
// module chunks = 35783957827783